<template>
    <div ref="root" class="relative" @keydown.esc="close">
        <button
            type="button"
            class="flex items-center gap-2 cursor-pointer"
            aria-haspopup="true"
            :aria-expanded="open"
            @click="open = !open"
        >
            <img v-if="userStore.avatar" :src="userStore.avatar" alt="" class="h-8 w-8 rounded-full">
            <span class="hidden sm:inline text-small">{{ userStore.name }}</span>
            <svg class="h-3 w-3 transition-transform" :class="open && 'rotate-180'" viewBox="0 0 12 12" aria-hidden="true">
                <path d="M2 4l4 4 4-4" fill="none" stroke="currentColor" stroke-width="1.5"/>
            </svg>
            <span class="sr-only">Account menu</span>
        </button>

        <div v-if="open" class="absolute right-0 top-full mt-3 z-20 w-64 bg-canvas border border-line-strong p-4 flex flex-col gap-4">
            <div>
                <p class="font-semibold">{{ userStore.name }}</p>
                <p v-if="userStore.email" class="text-small text-ink-muted truncate">{{ userStore.email }}</p>
            </div>
            <div class="flex flex-col gap-2 pt-4 border-t border-line">
                <span class="text-small text-ink-muted">Theme</span>
                <ThemeToggle class="self-start"/>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
const userStore = useUserStore()
const route = useRoute()

const open = ref(false)
const root = ref<HTMLElement>()

const close = () => {
    open.value = false
}

// Close on a click anywhere outside the menu, and after navigating
const onDocumentClick = (event: MouseEvent) => {
    if (root.value && !root.value.contains(event.target as Node)) close()
}
watch(open, (isOpen) => {
    if (isOpen) document.addEventListener('click', onDocumentClick)
    else document.removeEventListener('click', onDocumentClick)
})
watch(() => route.fullPath, close)
onBeforeUnmount(() => document.removeEventListener('click', onDocumentClick))
</script>
